import actionTypes from './actions'

const reducer = (state = {}, action = { type: '' }) => {
  const defaultState = {
    authenticated: false,
    displayFormErrors: false,
    first_load: true,
    last_person_slug: null,
    persons: {},
    scrollPosition: 0,
  }
  switch (action.type) {
    case actionTypes.addPersons:
      return {
        ...defaultState,
        ...state,
        persons: action.persons,
      }
    case actionTypes.disableFirstLoad:
      return {
        ...defaultState,
        ...state,
        first_load: false,
      }
    case actionTypes.displayFormErrors:
      return {
        ...defaultState,
        ...state,
        displayFormErrors: true,
      }
    case actionTypes.hideFormErrors:
      return {
        ...defaultState,
        ...state,
        displayFormErrors: false,
      }
    case actionTypes.login:
      return {
        ...defaultState,
        ...state,
        authenticated: true,
      }
    case actionTypes.logout:
      return {
        ...defaultState,
        ...state,
        authenticated: false,
      }
    case actionTypes.rememberPerson:
      return {
        ...defaultState,
        ...state,
        last_person_slug: action.slug,
      }
    case actionTypes.reset:
      return defaultState
    case actionTypes.storeScrollPosition:
      return {
        ...defaultState,
        ...state,
        scrollPosition: action.scrollPosition,
      }
    default:
      return {
        ...defaultState,
        ...state,
      }
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/gallery/reducer.js